import React, { ReactNode } from 'react'
import TextField from '@material-ui/core/TextField';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Grid, Theme } from '@material-ui/core';


interface Props {
    labelBefore?: JSX.Element | string | ReactNode,
    labelAfter?: JSX.Element | string | ReactNode,
    defaultValue?: string,
    disabled?: boolean,
    placeholder?: string,
    onChange?(event: any): any,
    onBlur?(event: any): any,
    value?: string | number | null | undefined,
    type?: string,
    error?: boolean,
    errorText?: string | ReactNode,
    readonly?: boolean,
    name?: string,
    id?: any
}

const useStyle = makeStyles({
    labelBefore: {
        paddingRight: "5px",
        paddingTop: "5px",
        textAlign: "right"
    },
    labelAfter: {
        paddingTop: "10px",
    },
    wrapper: {

    },
    textfield: {
        width: "100%"
    },
    disabled: {
        marginTop: "2px",
        color: "#cfcfcf"
    },
    outerGrid: {
        textAlign: "center"
    },
    input: {
        border: "unset",
    }
});

export default function TextFieldKTR(props: Props) {
    const classes = useStyle();
    const theme: Theme = useTheme();

    return (
        <div>
            <Grid container>
                <Grid style={{marginTop: "10px", marginLeft: "5px"}} item xs={12} sm={7}>
                    {props.labelBefore}
                </Grid>
                <Grid item xs={10} sm={3}>
                    <TextField
                        id={props.id}
                        name={props.name}
                        InputProps={{
                            readOnly: props.readonly,
                            disableUnderline: true,
                            className: (props.value !== undefined && props.value !== "" && props.readonly !== true) ? classes.input : ""
                        }}
                        InputLabelProps={{
                            style: { color: theme.palette.text.primary },
                            shrink: true,
                        }}
                        type={props.type}

                        fullWidth
                        error={props.error || false}
                        helperText={props.error ? props.errorText : ''}
                        onChange={props.onChange}
                        defaultValue={props.defaultValue}
                        onBlur={props.onBlur}
                        disabled={props.readonly || props.disabled}
                        placeholder={props.placeholder}
                        margin="dense"
                        value={props.value === undefined ? "" : props.value}

                    />
                </Grid>
                <Grid item xs={1} sm={1} style={{marginTop: "10px", marginLeft: "5px"}}>
                    {props.labelAfter}
                </Grid>


            </Grid>
        </div>
    )
}
